import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "container container-final d-flex flex-column" }
const _hoisted_2 = {
  class: "ml-5",
  for: "roundTrip"
}
const _hoisted_3 = {
  id: "main-transportation-title",
  class: "d-flex flex-column align-items-center justify-content-center"
}
const _hoisted_4 = { class: "font-big mt-5 transportation-title" }
const _hoisted_5 = { class: "font-weight-600" }
const _hoisted_6 = { class: "row row-cols-2 justify-content-center" }
const _hoisted_7 = { class: "d-flex justify-content-center tickets-button-container" }
const _hoisted_8 = { class: "d-flex flex-column align-items-end m-0 tickets-button-container__inner-first" }
const _hoisted_9 = {
  key: 0,
  class: "font-small error-color"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_CheckBoxComponent = _resolveComponent("CheckBoxComponent")!
  const _component_TransportationComponent = _resolveComponent("TransportationComponent")!
  const _component_TransportationTicketComponent = _resolveComponent("TransportationTicketComponent")!
  const _component_ButtonComponent = _resolveComponent("ButtonComponent")!

  return (_openBlock(), _createElementBlock("main", _hoisted_1, [
    _createVNode(_component_CheckBoxComponent, {
      onOnClick: _ctx.isRoundTrip,
      state: _ctx.roundTrip,
      id: 'roundTrip',
      name: "roundTrip",
      class: "checkbox-default mb-4"
    }, {
      "checkbox-text": _withCtx(() => [
        _createElementVNode("label", _hoisted_2, _toDisplayString(_ctx.$t('round_trip')), 1)
      ]),
      _: 1
    }, 8, ["onOnClick", "state"]),
    _createVNode(_component_TransportationComponent, { "round-trip": _ctx.roundTrip }, null, 8, ["round-trip"]),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.$t('passenger_transportation')), 1),
      _createElementVNode("h3", _hoisted_5, _toDisplayString(_ctx.pickUp.city) + " - " + _toDisplayString(_ctx.dropOff.city), 1)
    ]),
    _createElementVNode("div", _hoisted_6, [
      _createVNode(_component_TransportationTicketComponent, {
        "is-forward-ticket": true,
        "display-props": { imgUrl: '/images/next-arrow.svg', placeholder: 'choose_ticket_forward' },
        "forward-ticket": _ctx.forwardTicket
      }, null, 8, ["forward-ticket"]),
      _createVNode(_component_TransportationTicketComponent, {
        "is-forward-ticket": false,
        "display-props": { imgUrl: '/images/previous-arrow.svg', placeholder: 'choose_ticket_back' },
        "back-ticket": _ctx.backTicket
      }, null, 8, ["back-ticket"])
    ]),
    _createElementVNode("div", _hoisted_7, [
      _createElementVNode("div", _hoisted_8, [
        (_ctx.error.message)
          ? (_openBlock(), _createElementBlock("div", _hoisted_9, _toDisplayString(_ctx.$t(_ctx.error.message)), 1))
          : _createCommentVNode("", true),
        _createVNode(_component_ButtonComponent, {
          class: "order-form-submit-button final-button-margin tickets-button-container__inner-first__inner-second",
          onClick: _ctx.onOrder
        }, {
          btnContent: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t('order_now')), 1)
          ]),
          _: 1
        }, 8, ["onClick"])
      ])
    ])
  ]))
}